import { FileText } from 'lucide-react';

import { Button } from '@/components/Button/Button';
import type { BrandIntelligence, BrandIntelligenceParams } from '@/features/reports/api';
import { GENERATE_STATE } from '@/features/reports/brands/brandReport';
import { useGenerateReport } from '@/features/reports/brands/useGenerateReport';
import { BRANDS_COPY as COPY } from '@/features/reports/copy';
import { PdfViewer } from '@/features/orders/shipping/PdfViewer';

/**
 * The prototype's #bi-generate at the end of the controls row (ALS-93): the brand report PDF for
 * the brand and quarter on screen, in the document viewer with Download PDF and Print. Off
 * whenever the tab has no figures to give, which is every empty state, and while they load.
 * Full width on a phone, where the controls stack.
 */
export function GenerateReportButton({
    report,
    params,
    disabled,
}: {
    report: BrandIntelligence | undefined;
    params: BrandIntelligenceParams | undefined;
    disabled: boolean;
}) {
    const { state, generate, document, close } = useGenerateReport(report, params);
    const generating = state === GENERATE_STATE.Generating;

    return (
        <>
            <Button
                size="sm"
                disabled={disabled}
                loading={generating}
                onClick={() => void generate()}
                className="w-full sm:ml-auto sm:w-auto pointer-coarse:min-h-11"
            >
                {generating ? null : <FileText />}
                {generating
                    ? COPY.generate.working
                    : state === GENERATE_STATE.Ready
                      ? COPY.generate.done
                      : COPY.generate.label}
            </Button>
            <PdfViewer document={document} onClose={close} />
        </>
    );
}
